export const setSystems = (data) => {
  return {
    type: 'SET_SYSTEMS',
    payload: data
  };
};

export const setSystemsLoading = () => {
  return {
    type: 'SET_SYSTEMS_LOADING'
  };
};

export const setSystemDetails = (system, systemId) => {
  return {
    type: 'SET_SYSTEM_DETAILS',
    payload: {
      system,
      systemId
    }
  };
};
